import { createFileRoute, redirect } from "@tanstack/react-router";
import { getLiveSession } from "$/modules/projects/lib/live-sessions";

export const Route = createFileRoute("/$locale/live/$sessionId/host/")({
  loader: async ({ params }) => {
    const session = await getLiveSession(params.sessionId);
    throw redirect({
      to: "/$locale/quiz-player/$projectId/live/$sessionId",
      params: {
        locale: params.locale,
        projectId: session.projectId,
        sessionId: session.$id,
      },
    });
  },
});
